import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)

export async function api (method, url, param) {
  try {
    const { data } = await Vue.http[method](url, param)
    // console.log("res - url, param, data: ", url, param, data) // debug console
    return [null, data]
  } catch (err) {
    // console.log("err - url, param, data: ", url, param, err) // debug console
    return [err]
  }
} 



// WEBPACK FOOTER //
// ./src/api/main.api.js